<template>
  <div class="b-vehicle-compare-bar-card" title="Remove" @click="onClickCard">
    <div>
      <LazyImage v-if="image" :image="image" />
    </div>
    <div>
      <div class="extrabold">
        {{ item.manufacturer }} {{ item.short_model_name }}
      </div>
      <div class="semibold">{{ modelNameComputed }}</div>
    </div>
  </div>
</template>

<script>
import mixinsLeaseItNow from './../../mixins/leaseitnow-mixins'
import LazyImage from './../common/LazyImage.vue'

export default {
  components: { LazyImage },
  mixins: [mixinsLeaseItNow],
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    modelNameComputed() {
      if (!this.item) {
        return null
      }
      /* eslint-disable camelcase */
      const { model_name, short_model_name } = this.item
      const modelName = model_name.replace(short_model_name, '')

      return `${modelName} ${this.item.model_key}`
    },

    image() {
      return this.item.thumb
        ? {
            url: this.item.thumb,
            alt: '',
          }
        : null
    },
  },
  methods: {
    onClickCard() {
      this.removeRecordFromCompare({ value: this.item.vehicle_id })
    },
  },
}
</script>

<style scoped lang="scss">
.b-vehicle-compare-bar-card {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  img {
    max-height: 40px;
  }
}
</style>
